import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';
import ProgressReportCard from '../../components/ProgressReportCard';
import axios from 'axios';
import API_BASE from '../../utils/api';

const API = API_BASE;

const PrincipalProgressReports = () => {
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/classes`, { headers }).then((res) => setClasses(res.data)).catch(() => {});
  }, []);

  const fetchStudents = useCallback(async (classId) => {
    if (!classId) { setStudents([]); return; }
    try {
      const res = await axios.get(`${API}/classes/${classId}/students`, { headers });
      setStudents(res.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    setSelectedStudent('');
    fetchStudents(selectedClass);
  }, [selectedClass, fetchStudents]);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-800">📈 Progress Reports</h1>
              <p className="text-gray-500 mt-1">View and edit any student's progress report</p>
            </div>
            <ProfileDropdown />
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Class</label>
              <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
                <option value="">Select a class</option>
                {classes.map((c) => (
                  <option key={c._id} value={c._id}>{c.className} - {c.section}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Student</label>
              <select value={selectedStudent} onChange={(e) => setSelectedStudent(e.target.value)}
                disabled={!selectedClass}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 disabled:bg-gray-100">
                <option value="">Select a student</option>
                {students.map((s) => (
                  <option key={s._id} value={s._id}>{s.name} (Roll {s.rollNumber})</option>
                ))}
              </select>
            </div>
          </div>

          {selectedStudent && <ProgressReportCard studentId={selectedStudent} editable accentColor="purple" />}
        </div>
      </div>
    </div>
  );
};

export default PrincipalProgressReports;
